import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { RetryLink } from "@apollo/client/link/retry";
import { ApolloLink } from "@apollo/client";
import QueueLink from "apollo-link-queue";
import SerializeLink from "apollo-link-serialize";
import { onError } from "@apollo/client/link/error";

import * as Storage from "../storage";

const cmsHttpLink = createHttpLink({
  uri: process.env.REACT_APP_BACKEND_LOCATION + "/graphql",
});

const middlewareHttpLink = createHttpLink({
  uri: process.env.REACT_APP_MIDDLEWARE_LOCATION,
});

const cmsAuthLink = setContext(async (_, { headers }) => {
  const jwtToken = await Storage.TOKEN.get();
  return {
    headers: {
      ...headers,
      authorization: jwtToken ? `Bearer ${jwtToken}` : null,
    },
  };
});

const middlewareAuthLink = setContext(async (_, { headers }) => {
  const jwtToken = await Storage.TOKEN.get();
  return {
    headers: {
      ...headers,
      authorization: jwtToken,
    },
  };
});

const retryLink = new RetryLink();
const queueLink = new QueueLink();
const serializeLink = new SerializeLink();

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

export const client = new ApolloClient({
  link: ApolloLink.from([
    errorLink,
    queueLink,
    serializeLink,
    retryLink,
    ApolloLink.split(
      (operation) => operation.getContext().apiName === "cms",
      cmsAuthLink,
      middlewareAuthLink
    ),
    ApolloLink.split(
      (operation) => operation.getContext().apiName === "cms",
      cmsHttpLink,
      middlewareHttpLink
    ),
  ]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "ignore",
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all",
    },
  },
});
